export function useElectricField() {
  const wattToBhp = (watt: number): number => {
    if (!watt) {
      return 0
    }
    return Math.round(watt * 0.00134)
  }
  const bhpToWatt = (bhp: number): number => {
    if (!bhp) {
      return 0
    }
    return Math.round(bhp * 745.67)
  }

  return { wattToBhp, bhpToWatt }
}
